import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle, RefreshCw, ArrowLeft } from "lucide-react";

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <Card className="max-w-md w-full border-slate-200">
        <CardContent className="pt-12 pb-8 text-center">
          <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-12 h-12 text-slate-400" />
          </div>

          <h2 className="text-2xl font-bold text-slate-900 mb-2">
            Payment Cancelled
          </h2>
          <p className="text-slate-500 mb-8">
            No worries! Your payment was not processed. You can try again whenever you're ready.
          </p>

          <div className="space-y-3">
            <Button
              onClick={() => navigate("/upgrade")}
              className="w-full bg-slate-900 hover:bg-slate-800 text-white"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Try Again
            </Button>
            
            <Button
              onClick={() => navigate("/dashboard")}
              variant="outline"
              className="w-full border-slate-300"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Dashboard
            </Button>
          </div>

          {/* Help Section */}
          <div className="mt-8 pt-6 border-t border-slate-200">
            <p className="text-sm text-slate-500 mb-2">
              Need help with your purchase?
            </p>
            <a
              href="mailto:support@clarias.in"
              className="text-sm text-slate-900 font-medium hover:underline"
            >
              Contact Support →
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancelPage;
